module.exports = __webpack_public_path__ + "img/06.70ad8f1e.png";